import React from 'react';

// TODO - PRO-4274: add new impact widget in this component
export const ReferralTag = () => {
  return <span />;
};
